export function getCurrencyFlagHtml(data) {
    const currencyFlagMap = {
        "EUR-GBP": ["EU.svg", "GBP.svg"],
        "GBP-EUR": ["GBP.svg", "EU.svg"],
        "EUR-USD": ["EU.svg", "US.svg"],
        "GBP-USD": ["GBP.svg", "US.svg"],
        "USD-CZK": ["US.svg", "Czechia.svg"],
        "EUR-PLN": ["EU.svg", "PLN.svg"],
        "USD-PLN": ["US.svg", "PLN.svg"],
        "DKK-USD": ["DKK.svg", "US.svg"],
        "SEK-USD": ["SEK.svg", "US.svg"],
        "EUR-CZK": ["EU.svg", "Czechia.svg"],
        "EUR-DKK": ["EU.svg", "DKK.svg"],
        "EUR-CHF": ["EU.svg", "CHF.svg"],
        "EUR-SEK": ["EU.svg", "SEK.svg"],
        "GBP-PLN": ["GBP.svg", "PLN.svg"]
    };
    const flags = currencyFlagMap[data.name];
    if (flags) {
        return `<div class="imageCur"><img class="border-flagCur" src="/img/flagsCurrency/${flags[0]}"/><img class="border-flagCur" src="/img/flagsCurrency/${flags[1]}"/></div>`;
    }
    return "";
}




export function getFlagHtml(data) {
    if (!data || !data.state) return "";

    const flagMap = {
        "Germany": "Germany.svg",
        "Austria": "Austria.svg",
        "Italy": "Italy.svg",
        "Belgium": "Belgium.svg",
        "France": "France.svg",
        "United Kingdom": "GBP.svg",
        "Spain": "Spain.svg",
        "Czech Rep.": "Czech Rep.svg",
        "Netherlands": "Netherlands.svg",
        "Hungary": "Hungary.svg",
        "Slovakia": "Slovakia.svg",
        "Switzerland": "Switzerland.svg",
        "Poland": "PL.svg",
        "Denmark": "DK.svg",
        "Sweden": "Sweden.svg",
        "Norway": "Norway.svg",
        "Finland": "Finland.svg",
        "Ireland": "Ireland.svg",
        "Northern Ireland": "Northern Ireland.svg",
        "Romania": "Romania.svg",
        "Estonia": "Estonia.svg",
        "Lithuania": "Lithuania.svg",
        "Luxembourg": "Luxembourg.svg"
    };

    const flag = flagMap[data.state];
    if (flag) {
        return `<div class="image"><img class="border-flag" src="/img/flag/${flag}"/></div>`;
    }
    return "";
}

